import {AppState} from '../store';
import {format} from 'date-fns';

export const getPriceIncrease = (state: AppState) => state.priceIncrease;

export const getNextPriceIncreaseData = (state: AppState) => {
  if (state.priceIncrease.nextPrice) {
    const {timestamp, newPrice} = state.priceIncrease.nextPrice;
    
    let dateInput: any = isNaN(Number(timestamp)) ? timestamp : Number(timestamp);
    
    if (typeof dateInput === 'number' && dateInput < 1000000000) {
      dateInput *= 1000;
    }

    const date = new Date(dateInput);

    const displayDate = !isNaN(date.getTime()) 
      ? format(date, 'H:mm  d MMMM yyyy') 
      : (timestamp || 'Invalid date');

    return {
      timestamp: displayDate,
      newPrice: `${newPrice ? newPrice.toString() : '0'} USD`,
    };
  } else {
    return {
      timestamp: 'unknown time',
      newPrice: 'unknown',
    };
  }
};

export const getIsLoading = (state: AppState) => state.priceIncrease.isLoading;
